import React, { Fragment } from 'react';
import axios from 'axios';
import { get } from 'lodash';
import { API_URL } from '../../lib/const';
import { Card, Ball, InputDocumentFile } from '../elements';
import { Modal } from '../components';

class Documents extends React.Component {
  state = {
    showModal: false,
    content: [],
    fileSrc: null,
    loading: false,
  };

  showModal = (file) =>
    axios.get(`${API_URL}/uploads/${file.key}`).then((response) =>
      this.setState({
        showModal: true,
        content: file,
        fileSrc: get(response, 'data.url', null),
      })
    );

  onClose = () => this.setState({ showModal: false });

  handleUpload = (event) => {
    const { onUpload } = this.props;
    const file = get(event, 'target.files.0');
    if (file) {
      this.setState({ currentFile: file.name, loading: true });
      onUpload(event).then(() => {
        this.setState({ currentFile: null, loading: false });
      });
    } else {
      this.setState({ currentFile: null, loading: false });
    }
  };

  getUploadButton = () => {
    return (
      <div className="documents-upload">
        <div className="btn-none">
          <input
            type="file"
            style={{ cursor: 'pointer' }}
            className="input-file"
            value=""
            onChange={this.handleUpload}
          />
          <Ball icon="upload" small bgColor="white" iconWidth="18" />
        </div>
        <div className="documents-upload-description">
          <p>Fazer Upload</p>
          <p>Tipos de arquivo aceitos: PDF e imagens (JPG e PNG)</p>
        </div>
      </div>
    );
  };

  getRepprovedButton = () => {
    return (
      <div className="documents-upload">
        <div className="btn-none">
          <input
            type="file"
            style={{ cursor: 'pointer' }}
            className="input-file"
            value=""
          />
          <Ball icon="upload" small bgColor="white" iconWidth="18" />
        </div>
        <div className="documents-upload-description">
          <p style={{ color: 'red', fontWeight: 'bold' }}>
            O arquivo do seu documento foi reprovado.
          </p>
          <p style={{ fontWeight: 'bold' }}>
            Delete o arquivo enviado e faça o upload de um novo arquivo.
          </p>
          <p>Tipos de arquivo aceitos: PDF e imagens (JPG e PNG)</p>
        </div>
      </div>
    );
  };

  render() {
    const { showModal, content, currentFile, fileSrc, loading } = this.state;
    const {
      label,
      documents,
      onRemove,
      progress,
      error,
      is_required,
    } = this.props;

    return (
      <Fragment>
        <div className="col-sm-12 col-md-6 mt-5">
          <Card error={error} title={label}>
            {documents.map((file) => (
              <>
                <InputDocumentFile
                  key={file.name}
                  name={file.name}
                  showModal={() => this.showModal(file)}
                  removeFile={() => onRemove(file.key)}
                  approved={file.approved}
                />
              </>
            ))}
            {currentFile && (
              <InputDocumentFile name={currentFile} progress={progress} />
            )}
            {loading && (
              <Fragment>
                <p className="documents-none">
                  Carregando, por favor aguarde...
                </p>
              </Fragment>
            )}
            {documents.length === 0 &&
              (!is_required ? (
                <Fragment>
                  <p className="documents-non-required">
                    Documento complementar, poderá ser entregue após a
                    matrícula.
                  </p>
                </Fragment>
              ) : (
                <Fragment>
                  <p className="documents-required">Documento obrigatório</p>
                </Fragment>
              ))}

            {!loading && documents.length === 0 && (
              <Fragment>{this.getUploadButton()}</Fragment>
            )}
            {documents.map((file) => (
              <>
                {file.approved ? (
                  ''
                ) : (
                  <>
                    {file.approved === false ? (
                      <div>{this.getRepprovedButton()}</div>
                    ) : (
                      <div>{this.getUploadButton()}</div>
                    )}
                  </>
                )}
              </>
            ))}
          </Card>
        </div>
        <Modal
          visible={showModal}
          onClose={this.onClose}
          title={content.name}
          src={fileSrc}
        />
      </Fragment>
    );
  }
}

export default Documents;
